/**
 * BRXCheckoutSubmitting
 *
 * Transient feedback for the final Embeddables submit step: a spinner
 * overlay layered on top of the still-mounted intake host, and an error
 * banner shown above it when submission fails (e.g. phone conflict).
 *
 * Usage:
 *   var ui = window.BRXCheckoutSubmitting.mount(sectionRoot);
 *   ui.showSubmitting('Submitting your information…');
 *   ui.showError('That phone number is already in use.');
 *   ui.hideSubmitting();
 *   ui.hideError();
 */
(function () {
    function mount(root) {
        var submittingEl = root ? root.querySelector('[data-intake-submitting]') : null;
        var messageEl    = submittingEl ? submittingEl.querySelector('[data-intake-submitting-message]') : null;
        var errorEl      = root ? root.querySelector('[data-intake-error]') : null;

        function showSubmitting(message) {
            hideError();
            if (messageEl && message) messageEl.textContent = message;
            if (submittingEl) {
                submittingEl.classList.remove('is-hidden');
                submittingEl.setAttribute('aria-busy', 'true');
            }
        }

        function hideSubmitting() {
            if (submittingEl) {
                submittingEl.classList.add('is-hidden');
                submittingEl.setAttribute('aria-busy', 'false');
            }
        }

        function showError(message) {
            hideSubmitting();
            if (errorEl) {
                errorEl.textContent = message;
                errorEl.classList.remove('is-hidden');
            }
        }

        function hideError() {
            if (errorEl) errorEl.classList.add('is-hidden');
        }

        return {
            showSubmitting: showSubmitting,
            hideSubmitting: hideSubmitting,
            showError: showError,
            hideError: hideError
        };
    }

    window.BRXCheckoutSubmitting = { mount: mount };
})();
